import { FC } from "react";
import LayoutProfileSvg from "../../public/icons/LayoutProfile.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const LayoutProfileIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><LayoutProfileSvg/></span>;
